import { useState } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
// <<< Import specific icons needed
import { FaEnvelope, FaRegCopy } from 'react-icons/fa';

export const Contact = () => {
  const email = "pushkarshinalkar001@gmail.com";
  // <<< State to manage the copy button's text for user feedback
  const [copyButtonText, setCopyButtonText] = useState('Copy');

  // <<< Function to handle copying email to clipboard
  const handleCopy = () => {
    navigator.clipboard.writeText(email).then(() => {
      setCopyButtonText('Copied!');
      setTimeout(() => {
        setCopyButtonText('Copy');
      }, 2000); // Revert back after 2 seconds
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us" />
              }
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Get In Touch</h2>
                  <p>The fastest way to reach me is by email. Feel free to send a message directly or copy my address.</p>

                  {/* <<< NEW: Streamlined contact card */}
                  <div className="contact-card">
                    <FaEnvelope className="contact-icon" />
                    <div className="email-actions">
                      <a href={`mailto:${email}`} className="email-link">{email}</a>
                      <button onClick={handleCopy} className={`copy-button ${copyButtonText === 'Copied!' ? 'copied' : ''}`}>
                        <FaRegCopy /> {copyButtonText}
                      </button>
                    </div>
                  </div>
                </div>
              }
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
